import { Typography } from 'antd';
import { FC } from 'react';

import { getDateFactory } from '@/common/utils';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  lastCrawlTime: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['lastCrawlTime'] | null
}

export const LastCrawlTimeLabel: FC<Props> = ({ lastCrawlTime }) => {
  if (lastCrawlTime) {
    return <span>{ getDateFactory(lastCrawlTime, 'Aug 16, 2018 08:02', true) }</span>;
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
